enum SettingPath {
  PERSONAL_PROFILE = "personal/profile",
  PERSONAL_CALENDAR_SYNC = "personal/calendar-sync",
  PERSONAL_MAP_PREFERENCES = "personal/map-preferences",
  PERSONAL_EMAIL_PREFERENCES = "personal/email-preferences",
  PERSONAL_SESSIONS = "personal/sessions",
  ORGANIZATION_DETAILS = "organization/details",
  ORGANIZATION_CUSTOM_FIELDS = "organization/custom-fields",
  ORGANIZATION_ACTIVITY_TYPES = "organization/activity-types",
  ORGANIZATION_EMAIL = "organization/email",
  ORGANIZATION_FEATURES = "organization/features",
  ORGANIZATION_USERS_AND_PERMISSIONS = "organization/users-and-permissions",
  ORGANIZATION_INTEGRATIONS = "organization/integrations",
  ORGANIZATION_SANDBOX = "organization/sandbox",
  ORGANIZATION_SCORECARD = "organization/scorecard",
  DATA_NEW_IMPORT = "data/new-import",
  DATA_IMPORT_HISTORY = "data/import-history",
  DATA_RESTORABLE_RECORDS = "data/restorable-records",
  PRIVACY_NOTIFICATIONS = "privacy/notifications",
  PRIVACY_MARKETING = "privacy/marketing",
  FORMS_MANAGE_FIELDS = "forms/manage-fields",
  FORMS_CREATE = "forms/create-forms",
  FORMS_MERGE_DUPLICATES = "forms/merge-duplicates",
  FORMS_FILE_TAGS = "forms/file-tags",
  PINNED_FIELDS = "forms/pinned-fields",
}

export enum OrganizationDetailsTabs {
  GENERAL = "general",
  ACTIVITIES = "activities",
  MAP = "map",
  LEAD_GENERATION = "lead-generation",
  LEADERBOARD = "leaderboard",
  DATA = "data",
  DEFAULT_COLUMNS = "default-columns",
  EMAIL = "email",
  RESOURCES = "resources",
  DEALS = "deals",
  MILEAGE_TRACKING = "mileageTracking",
  SCORECARD = "scorecard",
  COACHING_AND_INSIGHTS = "coaching-and-insights",
}

export default SettingPath;
